import { useEffect, useState, Fragment, lazy } from "react";
import { useNavigate } from "react-router-dom";
import { MuiMaterials } from '../@index.js';
import * as Components from '../components/@index.js';
import * as global from '../data/global';
import * as _ from 'lodash';
import { useAuth } from "../provider/authProvider.js";
import { createApiEndpoint } from '../index.js';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import * as Assets from "../assets/@index";
import { attachHumidityLayoutSensorsToSite, isHumidityLayoutSensor, isHumiditySensor, temperatureSensorsFromCable } from '../3ds/bin/cable/humidity3d.js';
import axios from "axios";


export const CustomerSite = ({ ...props }) => {
    const navigate = useNavigate();
    const { clearToken, setToken } = useAuth();
    const [isLoading, setLoading] = useState(true);
    const [dragCard3dPosition, setDragCard3dPosition] = useState({ x: 0, y: -2 });

    useEffect(() => {
        initializeCustomerSite();
    }, []);

    const initializeCustomerSite = () => {
        const ctask = () => {
            return createApiEndpoint().fetchUserSite("compressed");
        };
        ctask().then((response) => {
            // Check if response is false (which might indicate a 401)
            if (response === false && global.gw.token && global.gw.auth) {
                // Server likely logged us out - throw 401 to trigger interceptor
                const authError = new Error('401 Unauthorized - Server logged out user');
                authError.response = { status: 401 };
                throw authError;
            }
            
            if (response) {
                global.gw.selectedSite.data = response.data.fetchUserSiteAttribute.sites[0];
                global.gw.selectedSite.layout = response.data.fetchUserSiteAttribute.sites[0].layout;
                global.gw.selectedSite.layoutGroups = response.data.fetchUserSiteAttribute.sites[0].layoutGroups;
                //  Sort layoutBins by isRound descending
                global.gw.selectedSite.layoutBins = response.data.fetchUserSiteAttribute.sites[0].layoutBins.sort((a, b) => b.isRound - a.isRound);//.filter(x => x.binName === "51");
                global.gw.selectedSite.layoutSides = response.data.fetchUserSiteAttribute.sites[0].layoutSides;//.filter(x => x.binName === "51");
                global.gw.selectedSite.layoutCables = response.data.fetchUserSiteAttribute.sites[0].layoutCables;
                global.gw.selectedSite.layoutSensors = response.data.fetchUserSiteAttribute.sites[0].layoutSensors;
                global.gw.selectedSite.aframes = response.data.fetchUserSiteAttribute.sites[0].aframes;
                global.gw.selectedSite.bins = Array.from(Array(global.gw.selectedSite.data.bins.length)).map((_, binIndex) => (global.getDefaultBin(0, binIndex)));
                global.gw.selectedSite.devices = response.data.fetchUserSiteAttribute.sites[0].devices;
                for (let b = 0; b < global.gw.selectedSite.bins.length; b++) {
                    let cables = global.gw.selectedSite.bins[b].cableList;
                    for (var c = 0; c < cables.length; c++) {
                        global.gw.selectedSite.cables.push(cables[c]);
                    }
                }

                global.gw.selectedSite.main = {
                    siteName: response.data.fetchUserSiteAttribute.sites[0].main.siteName,
                    bins: response.data.fetchUserSiteAttribute.sites[0].main.bins,
                    plus: response.data.fetchUserSiteAttribute.sites[0].main.plus,
                    minus: response.data.fetchUserSiteAttribute.sites[0].main.minus,
                };

                let siteLastScanIso = global.gw.selectedSite.data.lastScan;

                //let em = global.gw.email;
                //let bo = global.gw.bolts;

                //  Test decompress gzip
                //let tessfi = "";

                global.initializeSiteLayout();

                //let tesfasdf = global.gw.sites[global.gw.selectedSiteIndex];
                //let tasdfasdf = 0;

                //  Account for layoutCables if not in fetch
                if (!global.gw.selectedSite.layoutCables || global.gw.selectedSite.layoutCables.length === 0) {
                    if (global.gw.selectedSite.bins && global.gw.selectedSite.bins.length > 0) {
                        let customerSiteLayoutCableId = 1;
                        let customerSiteLayoutSensorId = 1;
                        global.gw.selectedSite.bins.map((bin, b) => {
                            if (bin.cableList && bin.cableList.length > 0) {
                                if (bin.diameter > 0) {
                                    bin.width = bin.diameter;
                                    bin.length = bin.diameter;
                                    bin.radius = bin.diameter / 2.0;
                                }

                                let layoutBin = global.gw.selectedSite.layoutBins.filter(x => x.binName === bin.binName);
                                if (layoutBin && layoutBin.length > 0) {
                                    layoutBin = layoutBin[0];
                                    bin.cableList.forEach(cable => {
                                        let layoutCable = {
                                            customerSiteLayoutCableId: customerSiteLayoutCableId++,
                                            customerSiteLayoutId: layoutBin.customerSiteLayoutId,
                                            customerSiteLayoutGroupId: layoutBin.customerSiteLayoutGroupId,
                                            customerSiteLayoutBinId: layoutBin.customerSiteLayoutBinId,
                                            binOrder: cable.number,
                                            binId: bin.binDataId,
                                            cableId: cable.id,
                                            cableName: cable.name,
                                            width: Math.abs(cable.bottomPointX - cable.topPointX),
                                            length: Math.abs(cable.bottomPointZ - cable.topPointZ),
                                            height: cable.sensorCount * (cable.sensorSpacing - 1) / 2,
                                            x: cable.topPointX,
                                            y: (cable.sensorCount * (cable.sensorSpacing - 1)) / 2.0,
                                            z: cable.topPointZ,
                                            topPointX: cable.topPointX,
                                            topPointY: cable.firstSensorHeight + cable.sensorCount * (cable.sensorSpacing - 1) / 2.0,
                                            topPointZ: cable.topPointZ,
                                            bottomPointX: cable.topPointX,
                                            bottomPointY: cable.firstSensorHeight,
                                            bottomPointZ: cable.topPointZ,
                                        };
                                        global.gw.selectedSite.layoutCables.push(layoutCable);
                                        //if (layoutCable.cableName == "South Tank 42-1") {
                                        //let test = 0;
                                        //}
                                        const tempSensors = temperatureSensorsFromCable(cable);
                                        if (tempSensors.length > 0) {
                                            let sensorSpacing = layoutCable.height / tempSensors.length;
                                            let sensorY = layoutCable.bottomPointY;
                                            tempSensors.sort((a, b) => {
                                                return a.position - b.position;
                                            }).forEach(sensor => {
                                                const showLiveTemp =
                                                    siteLastScanIso &&
                                                    global.sensorReadMatchesSiteLastScan(siteLastScanIso, sensor.lastGoodTempCheck) &&
                                                    global.isLiveTemperatureReading(sensor.temperature);
                                                const parsedTemp = parseFloat(sensor.temperature);
                                                let layoutSensor = {
                                                    customerSiteLayoutSensorId: customerSiteLayoutSensorId++,
                                                    customerSiteLayoutCableId: layoutCable.customerSiteLayoutCableId,
                                                    customerSiteLayoutId: layoutCable.customerSiteLayoutId,
                                                    customerSiteLayoutGroupId: layoutCable.customerSiteLayoutGroupId,
                                                    customerSiteLayoutBinId: layoutCable.customerSiteLayoutBinId,
                                                    cableOrder: sensor.position,
                                                    binId: bin.binDataId,
                                                    cableId: cable.id,
                                                    sensorId: sensor.id,
                                                    sensorName: sensor.name,
                                                    sensorValueString: showLiveTemp ? String(sensor.temperature).trim() : "-E-",
                                                    sensorValueNumber: showLiveTemp && Number.isFinite(parsedTemp) ? parsedTemp : null,
                                                    x: layoutCable.topPointX,
                                                    y: sensorY,
                                                    z: layoutCable.topPointZ,
                                                };
                                                global.gw.selectedSite.layoutSensors.push(layoutSensor);
                                                sensorY += sensorSpacing;
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    }
                }

                //  Add Aframes to layoutCables
                if (global.gw.selectedSite.layoutCables && global.gw.selectedSite.layoutCables.length > 0) {
                    global.gw.selectedSite.layoutCables.forEach(layoutCable => {
                        let cable = global.gw.selectedSite.cables.find(x => x.id === layoutCable.cableId);
                        if (cable) { 
                            layoutCable.aframe = global.gw.selectedSite.aframes.find(x => x.id === cable.aframeId);
                            if (layoutCable.aframe) {
                                cable.sensorList.forEach(sensor => {
                                    if (isHumiditySensor(sensor)) return;
                                    let layoutSensor = global.gw.selectedSite.layoutSensors.find(x => x.sensorId === sensor.id);
                                    if (layoutSensor && !isHumidityLayoutSensor(layoutSensor)) {
                                        layoutSensor.x = sensor.positionX;
                                        layoutSensor.y = sensor.positionY + 4;
                                        layoutSensor.z = sensor.positionZ;
                                    }
                                });
                            }
                        }
                    });
                }

                attachHumidityLayoutSensorsToSite(global.gw.selectedSite);
                global.syncLayoutSensorValuesFromCableSensors();

                global.gw.selectedSite.isSiteInitialized = true;

                if (typeof window !== "undefined" && window.dispatchEvent) {
                    window.dispatchEvent(new CustomEvent("grainwaveSelectedSiteReady"));
                }

                setLoading(false);
                window.scrollTo(0, 0);
            }
            else {
                navigate("/sites");
            }
        }).catch(function (error) {
            if (global.gw.test) {
                // console.log(error.message);
            }
            
            // If it's a 401 error, manually trigger the redirect (interceptor only catches axios errors)
            if (error.response && error.response.status === 401) {
                // console.log('CustomerSite: 401 error detected, clearing auth and redirecting to login');
                // Clear authentication state
                clearToken();
                delete axios.defaults.headers.common["Authorization"];
                global.gw.token = null;
                global.gw.auth = null;
                global.gw.isAuthenticated = false;
                // Redirect to login page
                setTimeout(() => {
                    window.location.href = "/emailLogin";
                }, 100);
                return;
            }
            // Also check for error message containing "401"
            if (error.message && (error.message.includes("401") || error.message.includes("Unauthorized"))) {
                // console.log('CustomerSite: Unauthorized error detected, clearing auth and redirecting to login');
                // Clear authentication state
                clearToken();
                delete axios.defaults.headers.common["Authorization"];
                global.gw.token = null;
                global.gw.auth = null;
                global.gw.isAuthenticated = false;
                // Redirect to login page
                setTimeout(() => {
                    window.location.href = "/emailLogin";
                }, 100);
                return;
            }
            
            if (global.gw.bypass) {
                global.gw.token = "test token";
                global.gw.auth = "test token";
                navigate("/dashboard", { replace: true });
                setLoading(false);
                window.scrollTo(0, 0);
            }
            else {
                if (error.message &&
                    error.message.endsWith("401") &&
                    global.gw.token &&
                    global.gw.auth) {
                    createApiEndpoint(global.Endpoints.GrainWave)
                        .fetchRenew()
                        .then(r => {
                            if (r && global.gw.token) {
                                setToken(global.gw.token);
                                initializeCustomerSite();
                            } else {
                                clearToken();
                                navigate("/", { replace: true });
                                setLoading(false);
                                window.scrollTo(0, 0);
                            }
                        })
                        .catch(() => {
                            clearToken();
                            navigate("/", { replace: true });
                            setLoading(false);
                            window.scrollTo(0, 0);
                        });
                }
                else {
                    //clearToken();
                    navigate("/", { replace: true });
                    setLoading(false);
                    window.scrollTo(0, 0);
                }
            }
        });
    };

    if (isLoading) {
        return (
            <MuiMaterials.Box 
                sx={{
                    fontSize: "50px",
                    color: "rgb(244, 204, 142)",
                    margin: "auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    right: "0",
                    left: "0%",
                    top: "0",
                    bottom: "10%",
                    marginTop: "252px",
                }}
            >
                <MuiMaterials.RotatingLines
                    strokeColor="#f4cc8e"
                    strokeWidth="3"
                    animationDuration="0.72"
                    width="48"
                    visible={true}
                />
            </MuiMaterials.Box>
        );
    }

    const renderNavigationBar = (siteName) => {
        if (global.gw.selectedSite.refreshId) {
            clearTimeout(global.gw.selectedSite.refreshId);
        }
        return (
            <MuiMaterials.Box
                sx={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                    alignItems: "stretch",
                    overflowX: "auto",
                    //paddingBottom: "4px",
                    textWrap: "nowrap",
                }}
            >
                <MuiMaterials.BottomNavigation
                    showlabel={true}
                    sx={{
                        //marginTop: "5px",
                        //height: "40px",
                        justifyContent: "flex-start",
                        background: "#2d2d2d",
                    }}
                >
                    <p
                        style={{
                            fontWeight: "900",
                            fontSize: "20px",
                            color: "#f4cc8e",
                            display: "flex",
                            alignItems: "center",
                            padding: "10px 20px",
                        }}
                    >
                        {global.gw.selectedSite.siteName}
                    </p>
                </MuiMaterials.BottomNavigation>
            </MuiMaterials.Box>
        );
    };

    const renderSettingsData = (nodes) => (
        <MuiMaterials.Box
            key={nodes.key}
            id={nodes.binId}
            name={nodes.name}
            className={nodes.className}
            sx={nodes.style}
        >
            {Array.isArray(nodes.children) ? nodes.children.map((node) => renderSettingsData(node)) : nodes.value}
        </MuiMaterials.Box>
    );

    document.title = global.gw.selectedSite.siteName;

    const tiles = [
        {
            title: "Sites",
            onClick: () => {
                navigate("/sites");
            }
        },
        {
            title: "Site 3D",
            onClick: (ev) => {
                let dragElements = window.document.getElementsByClassName("react-draggable");
                if (dragElements) {
                    Array.from(dragElements).map(x => {
                        x.style.zIndex = "1";
                        return true;
                    });
                }

                let es = window.document.getElementsByName("Site 3D");
                if (es) {
                    Array.from(es).map(e => {
                        if (e.style.display === "none") {
                            e.style.display = null;
                            ev.currentTarget.style.color = "rgb(244, 204, 142)";
                            ev.currentTarget.style.opacity = "1";
                        }
                        else {
                            e.style.display = "none";
                            ev.currentTarget.style.opacity = "0.25";
                        }
                        return true;
                    });
                }

                let reportWindow3d = window.document.getElementsByClassName("reportWindow")[0];
                if (reportWindow3d) {
                    reportWindow3d.style.display = "none";
                }

                //global.setAllCablesOn();
            }
        },
        {
            title: (<p>CO<sub>2</sub></p>),
            onClick: (ev) => {
                let dragElements = window.document.getElementsByClassName("react-draggable");
                if (dragElements) {
                    Array.from(dragElements).map(x => {
                        x.style.zIndex = "1";
                        return true;
                    });
                }

                let carbonDioxideWindow = window.document.getElementsByClassName("carbonDioxideWindow")[0];
                if (carbonDioxideWindow) {
                    if (carbonDioxideWindow.style.display === "none" || carbonDioxideWindow.style.display === "") {
                        carbonDioxideWindow.style.display = "flex";
                        ev.currentTarget.style.color = "rgb(244, 204, 142)";
                    }
                    else if (carbonDioxideWindow.style.display === "flex") {
                        carbonDioxideWindow.style.display = "none";
                        ev.currentTarget.style.color = "rgb(244, 204, 142, 0.25)";
                    }
                }

                let site3dWindow = window.document.getElementsByName("Site 3D")[0];
                if (site3dWindow) {
                    site3dWindow.style.display = "none";
                }

                let scanWindow = window.document.getElementsByClassName("scanWindow")[0];
                if (scanWindow) {
                    scanWindow.style.display = "none";
                }

                let reportWindow = window.document.getElementsByClassName("reportWindow")[0];
                if (reportWindow) {
                    reportWindow.style.display = "none";
                }

                let graphWindow = window.document.getElementsByClassName("graphWindow")[0];
                if (graphWindow) {
                    graphWindow.style.display = "none";
                }

                let navToggles = window.document.getElementsByClassName("navToggle");
                Array.from(navToggles).map(x => {
                    if (ev.currentTarget !== x) {
                        x.style.color = "rgb(244, 204, 142, 0.25)";
                    }
                });
            }
        },
        {
            title: "Sensor History Graph",
            onClick: (ev) => {
                let dragElements = window.document.getElementsByClassName("react-draggable");
                if (dragElements) {
                    Array.from(dragElements).map(x => {
                        x.style.zIndex = "1";
                        return true;
                    });
                }

                let graphWindow = window.document.getElementsByClassName("graphWindow")[0];
                if (graphWindow) {
                    if (graphWindow.style.display === "none" || graphWindow.style.display === "") {
                        graphWindow.style.display = "flex";
                        ev.currentTarget.style.color = "rgb(244, 204, 142)";
                    }
                    else if (graphWindow.style.display === "flex") {
                        graphWindow.style.display = "none";
                        ev.currentTarget.style.color = "rgb(244, 204, 142, 0.25)";
                    }
                }

                let site3dWindow = window.document.getElementsByName("Site 3D")[0];
                if (site3dWindow) {
                    site3dWindow.style.display = "none";
                }

                let scanWindow = window.document.getElementsByClassName("scanWindow")[0];
                if (scanWindow) {
                    scanWindow.style.display = "none";
                }

                let reportWindow = window.document.getElementsByClassName("reportWindow")[0];
                if (reportWindow) {
                    reportWindow.style.display = "none";
                }

                let carbonDioxideWindow = window.document.getElementsByClassName("carbonDioxideWindow")[0];
                if (carbonDioxideWindow) {
                    carbonDioxideWindow.style.display = "none";
                }

                let navToggles = window.document.getElementsByClassName("navToggle");
                Array.from(navToggles).map(x => {
                    if (ev.currentTarget !== x) {
                        x.style.color = "rgb(244, 204, 142, 0.25)";
                    }
                });
            }
        },
        {
            title: "Scan",
            onClick: (ev) => {
                let dragElements = window.document.getElementsByClassName("react-draggable");
                if (dragElements) {
                    Array.from(dragElements).map(x => {
                        x.style.zIndex = "1";
                        return true;
                    });
                }

                let scanWindow = window.document.getElementsByClassName("scanWindow")[0];
                if (scanWindow) {
                    if (scanWindow.style.display === "none" || scanWindow.style.display === "") {
                        scanWindow.style.display = "flex";
                        ev.currentTarget.style.color = "rgb(244, 204, 142)";
                    }
                    else if (scanWindow.style.display === "flex") {
                        scanWindow.style.display = "none";
                        ev.currentTarget.style.color = "rgb(244, 204, 142, 0.25)";
                    }
                }

                let site3dWindow = window.document.getElementsByName("Site 3D")[0];
                if (site3dWindow) {
                    site3dWindow.style.display = "none";
                }

                let reportWindow = window.document.getElementsByClassName("reportWindow")[0];
                if (reportWindow) {
                    reportWindow.style.display = "none";
                }

                let graphWindow = window.document.getElementsByClassName("graphWindow")[0];
                if (graphWindow) {
                    graphWindow.style.display = "none";
                }

                let carbonDioxideWindow = window.document.getElementsByClassName("carbonDioxideWindow")[0];
                if (carbonDioxideWindow) {
                    carbonDioxideWindow.style.display = "none";
                }

                let navToggles = window.document.getElementsByClassName("navToggle");
                Array.from(navToggles).map(x => {
                    if (ev.currentTarget !== x) {
                        x.style.color = "rgb(244, 204, 142, 0.25)";
                    }
                });
            }
        },
        {
            title: "Comparison Report",
            onClick: (ev) => {
                let dragElements = window.document.getElementsByClassName("react-draggable");
                if (dragElements) {
                    Array.from(dragElements).map(x => {
                        x.style.zIndex = "1";
                        return true;
                    });
                }

                let reportWindow = window.document.getElementsByClassName("reportWindow")[0];
                if (reportWindow) {
                    if (reportWindow.style.display === "none" || reportWindow.style.display === "") {
                        reportWindow.style.display = "flex";
                        ev.currentTarget.style.color = "rgb(244, 204, 142)";
                    }
                    else if (reportWindow.style.display === "flex") {
                        reportWindow.style.display = "none";
                        ev.currentTarget.style.color = "rgb(244, 204, 142, 0.25)";
                    }
                }

                let scanWindow = window.document.getElementsByClassName("scanWindow")[0];
                if (scanWindow) {
                    scanWindow.style.display = "none";
                }

                let graphWindow = window.document.getElementsByClassName("graphWindow")[0];
                if (graphWindow) {
                    graphWindow.style.display = "none";
                }

                let carbonDioxideWindow = window.document.getElementsByClassName("carbonDioxideWindow")[0];
                if (carbonDioxideWindow) {
                    carbonDioxideWindow.style.display = "none";
                }

                let site3dWindow = window.document.getElementsByName("Site 3D")[0];
                if (site3dWindow) {
                    site3dWindow.style.display = "none";
                }

                let navToggles = window.document.getElementsByClassName("navToggle");
                Array.from(navToggles).map(x => {
                    if (ev.currentTarget !== x) {
                        x.style.color = "rgb(244, 204, 142, 0.25)";
                    }
                });
            }
        },
    ];

    return (
        <MuiMaterials.Box>
            <MuiMaterials.Box
                sx={{
                    overflow: "hidden",
                    marginTop: "60px",
                    borderRadius: "0.75rem",
                    border: "1px solid rgba(244, 204, 142, 0.25)",
                    background: "linear-gradient(135deg, rgba(45, 45, 45, 0.55) 60%, rgba(50,50,60,0.35) 100%)",
                    backdropFilter: "blur(12px)",
                    WebkitBackdropFilter: "blur(12px)",
                    color: "var(--card-foreground, #fff)",
                    boxShadow: "0 8px 32px 0 rgba(0,0,0,0.25), 0 1.5px 8px 0 rgba(244,204,142,0.10)",
                }}
            >
                {renderNavigationBar(global.gw.selectedSite.siteName)}
                <MuiMaterials.Box
                    sx={{
                        //position: "fixed",
                        overflowY: "scroll",
                        overflowX: "hidden",
                        paddingRight: "25px",
                        boxSizing: "content-box",
                        width: "100vw",
                        maxHeight: "80vh",
                        bgcolor: '#2d2d2d',
                        display: "flex",
                        alignContent: "center",
                        alignItems: "stretch",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        marginBottom: "-45px",
                    }}
                >
                    {tiles.map((tile, index) => (
                        <MuiMaterials.Box
                            key={`tiles_grid${index}`}
                            size={6}
                            sx={{
                                bgcolor: "transparent",
                                overscrollBehavior: "auto",
                                width: "100px",
                                height: "100px",
                                borderRadius: "0.75rem",
                                border: "1px solid rgba(244, 204, 142, 0.25)",
                                background: "linear-gradient(135deg, rgba(45, 45, 45, 0.55) 60%, rgba(50,50,60,0.35) 100%)",
                                backdropFilter: "blur(12px)",
                                WebkitBackdropFilter: "blur(12px)",
                                color: "var(--card-foreground, #fff)",
                                boxShadow: "0 8px 32px 0 rgba(0,0,0,0.25), 0 1.5px 8px 0 rgba(244,204,142,0.10)",
                                margin: "auto",
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignContent: "space-around",
                                justifyContent: "space-around",
                                cursor: "pointer",
                                margin: "10px",
                                textAlign: "center",
                            }}
                            onClick={tile.onClick}
                        >
                            <MuiMaterials.Box
                                key={`tiles_tilecard${tile}`}
                                siteIndex={index}
                            >
                                <MuiMaterials.Card
                                    sx={{
                                        bgcolor: "transparent",
                                        display: "flex",
                                        alignItems: "center",
                                        //borderColor: "transparent",
                                        //borderWidth: "1px",
                                        //borderStyle: "none",
                                        boxShadow: "none",
                                        //justifyContent: "space-between",
                                    }}
                                >
                                    <MuiMaterials.Box
                                        sx={{
                                            display: "inline-grid",
                                            padding: "5px",
                                            flex: 1,
                                        }}
                                    >
                                        <Fragment>
                                            <MuiMaterials.Typography
                                                key={`tilecard_typo${index}`}
                                                sx={{
                                                    fontFamily: Assets.Fonts.MontserratExtraLightName,
                                                    color: "#f4cc8e",
                                                    //color: "#a8abb1",
                                                    //backgroundImage: "linear-gradient(#ffe2aa 58%, #f4cc8e 100%)",
                                                    //backgroundImage: "linear-gradient(red, blue)",
                                                    //color: "transparent",
                                                    //backgroundClip: "text",
                                                    //textShadow: "0.25px 0.25px 0px rgba(222, 175, 87, 1)",
                                                    fontSize: 12,
                                                    fontWeight: 1000,
                                                    //margin: "0px 10px",
                                                    //flexGrow: 1,
                                                }}
                                            >
                                                {tile.title}
                                            </MuiMaterials.Typography>
                                        </Fragment>
                                        {tile.component}
                                    </MuiMaterials.Box>
                                </MuiMaterials.Card>
                            </MuiMaterials.Box>
                        </MuiMaterials.Box>
                    ))}
                    <div style={{ height: "180px" }} />
                </MuiMaterials.Box>
        </MuiMaterials.Box>
            <div
                name="Site 3D"
                style={{
                    display: "none"
                }}
            >
                <Components.Site3dWindow />
            </div>
            <div name="CO2">
                <Components.CarbonDioxideWindow />
            </div>
            <div name="Graph">
                <Components.SensorTemperatureGraphWindow />
            </div>
            <div name="Scan">
                <Components.ScanWindow />
            </div>
            <div name="Report">
                <Components.ReportWindow />
            </div>
        </MuiMaterials.Box>
    );
}

export default CustomerSite;